export default __webpack_public_path__ + "static/media/card-2-bg-mb@2x.7c905155.jpg";